<template>
  <div id="result" class="result_container container">
    <div class="result_header">
      <h3 v-bind:aria-label="title">
        <span>{{ title }}</span>
      </h3>
    </div>
    <div class="result_image">
      <img
        v-bind:src="response.image"
        alt="banner"
        width="500px"
        height="300px"
        class="sv_image_image"
        style="object-fit: contain"
      />
    </div>
    <div class="result_header">
      <h1 v-bind:aria-label="response.header" class="">
        <span>{{ response.header }}</span>
      </h1>
    </div>
    <div class="result_text">
      <p v-bind:aria-label="response.text" v-html="description" />
    </div>    
    <div v-if="response.buttonText && response.buttonLink" class="sv_nav">
      <a v-bind:href="response.buttonLink">
        <input
          type="button"
          v-bind:value="response.buttonText"
          class="pds-c-button quiz-button"
        />
      </a>
    </div>
    <div class="sv_nav result_navigate">
      <router-link to="/compare">
        <div>Bekijk juiste antwoorden</div>
      </router-link>
    </div>    
    <Socials />
  </div>
</template>

<script>
import Socials from '../components/Socials.vue';

export default {
  name: "Result",
  components: {
    Socials
  },
  computed: {
    title() {
      return this.$store.state.config.title;
    },
    description() {
      return `Je hebt ${this.correctCount} van de ${this.noOfQuestions} vragen goed beantwoord. ${this.response.text}`;
    },
    response() {
      let correct = this.$store.state.correctCount;
      let res = null;
      this.$store.state.config.responses.forEach((response) => {
        if (correct >= response.min && correct <= response.max) {
          res = response;
        }
      });
      return res;
    },
    answers() {
      return this.$store.state.answers;
    },
    correctCount() {
      return this.$store.state.correctCount;
    },
    noOfQuestions() {
      return this.$store.state.noOfQuestions;
    },
  },
  beforeMount() {
    if (!this.$store.state.answers) {
      this.$router.push({ path: "/" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.result_container span {
  font-size: 0.9em;
}

@media only screen and (min-width: 768px) {
  .result_container span {
    font-size: 1em;
  }
}
</style>